import React from "react";
// import MomentUtils from "@date-io/moment";
import {DatePicker, KeyboardDatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import {getLabel} from "../../localization/MainLocalization";
// zimport DateFnsUtils from "@date-io/date-fns";
import MomentUtils from '@date-io/moment';
import moment from "moment";
import {not_validate_value} from "../../App";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import ClearIcon from "@material-ui/icons/Clear";

export const DateField = props=>{
    const handleDateChange = date =>{
        let value = moment(date).format("YYYY-MM-DD");
        if(value === "Invalid date"){
            value = null
        }
        props.onChangeHandle(props.name, value)
    }

    const handleClearDate = e => {
        e.stopPropagation();
        props.onChangeHandle(props.name, null)
    }

    return(
        <MuiPickersUtilsProvider utils={MomentUtils}>
                <DatePicker
                    views={props.withoutDays && ["year", "month"]}
                    autoOk
                    disableToolbar
                    animateYearScrolling
                    disabled={props.viewOnly}
                    className={props.disabled ? "disabled-field" : ""}
                    error={props.error}
                    helperText={props.helper_text || null}
                    inputVariant="outlined"
                    variant="inline"
                    format={!props.withoutDays && "YYYY-MM-DD"}
                    label={<label> {props.label}<span className='text-danger'>{props.required ? "*" : ""}</span></label>}
                    minDate={props.min_date || undefined}
                    fullWidth
                    maxDate={props.maxDate || undefined}
                    value={not_validate_value.includes(props.value)? null : props.value || null}
                    onChange={handleDateChange}
                    InputProps={!props.viewOnly && !props.disabled &&{
                         endAdornment: (
                            <InputAdornment position="end">
                                <IconButton onClick={handleClearDate}>
                                    <ClearIcon />
                                </IconButton>
                            </InputAdornment>
                        )
                    }}
                />
        </MuiPickersUtilsProvider>
    );
}
